import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Landing from './pages/Landing';
import Login from './pages/Login';
import About from './pages/About';
import Contact from './pages/Contact';
import NoteList from './pages/NoteList';
import ProtectedRoute from './components/ProtectedRoute';
import RootLayout from './components/layout/RootLayout';
import Dashboard from './pages/Dashboard';
import PaymentsPage from './pages/PaymentsPage';
import GroceryPage from './pages/GroceryPage';
import DocumentsPage from './pages/DocumentsPage';
import ReportsPage from './pages/ReportsPage';
import CalendarPage from './pages/CalendarPage';
import SettingsPage from './pages/SettingsPage';

// management pages
import ManageProjects from './pages/ManageProjects';
import ManageAssignees from './pages/ManageAssignees';
import ManageStatuses from './pages/ManageStatuses';
import ManagePaymentTypes from './pages/ManagePaymentTypes';
import ManageExpenseFroms from './pages/ManageExpenseFroms';
import ProfilePage from './pages/ProfilePage';
import PmaApp from './pma/PmaApp';
import Chat from './pages/Chat';
import FriendRequests from './pages/FriendRequests';
import Tunes from './pages/Tunes';
import Videos from './pages/Videos';

export default function App() {
  return (
    <Router>
      {/* RootLayout wraps ALL pages — public marketing header vs authenticated sidebar shell */}
      <RootLayout>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          {/* Protected: Dashboard */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/payments" element={<ProtectedRoute><PaymentsPage /></ProtectedRoute>} />
          <Route path="/grocery" element={<ProtectedRoute><GroceryPage /></ProtectedRoute>} />
          <Route path="/documents" element={<ProtectedRoute><DocumentsPage /></ProtectedRoute>} />
          <Route path="/documents/:folderId" element={<ProtectedRoute><DocumentsPage /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><ReportsPage /></ProtectedRoute>} />
          <Route path="/calendar" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
          <Route path="/password-generator" element={<ProtectedRoute><Home section="password" /></ProtectedRoute>} />
          <Route path="/internet-speed" element={<ProtectedRoute><Home section="speed" /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />

          {/* Protected: Notes */}
          {/*
            One splat route for /notes, /notes/create and /notes/edit/:slug.
            Separate <Route> elements would unmount and remount NoteList (and
            reload the list) every time the add/edit dialog opens or closes.
          */}
          <Route
            path="/notes/*"
            element={
              <ProtectedRoute>
                <NoteList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chat"
            element={
              <ProtectedRoute>
                <Chat />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chat/friends"
            element={
              <ProtectedRoute>
                <FriendRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tunes"
            element={
              <ProtectedRoute>
                <Tunes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tunes/own"
            element={
              <ProtectedRoute>
                <Tunes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tunes/others"
            element={
              <ProtectedRoute>
                <Tunes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tunes/playlists"
            element={
              <ProtectedRoute>
                <Tunes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tunes/playlists/:playlistId"
            element={
              <ProtectedRoute>
                <Tunes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/videos/*"
            element={
              <ProtectedRoute>
                <Videos />
              </ProtectedRoute>
            }
          />

          {/* Protected: Managements */}
          <Route
            path="/manage/projects"
            element={
              <ProtectedRoute>
                <ManageProjects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manage/assignees"
            element={
              <ProtectedRoute>
                <ManageAssignees />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manage/statuses"
            element={
              <ProtectedRoute>
                <ManageStatuses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manage/payment-types"
            element={
              <ProtectedRoute>
                <ManagePaymentTypes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manage/expensees"
            element={
              <ProtectedRoute>
                <ManageExpenseFroms />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manage/expense-froms"
            element={<Navigate to="/manage/expensees" replace />}
          />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          {/* Company-scoped nested resources */}

          {/* Protected: PMA (project management module, own sub-routes) */}
          <Route path="/pma/*" element={<ProtectedRoute><PmaApp /></ProtectedRoute>} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </RootLayout>
    </Router>
  );
}
